import ServiceService from '@/services/ServiceService'

export default {
  namespaced: true,

  state: {
    isFetching: false,
    services: [],
    camps: [],
    pds: []
  },

  getters: {},

  mutations: {
    set (state, services) {
      state.services = services
    },

    setCamps (state, camps) {
      state.camps = camps
    },

    setPds (state, pds) {
      state.pds = pds
    },

    setIsFetching (state, isFetching) {
      state.isFetching = isFetching
    }
  },

  actions: {
    fetch ({ commit, state }) {
      commit('setIsFetching', true)

      return ServiceService.getAll()
        .then(({ services }) => {
          commit('set', services)
          commit('setIsFetching', false)
          return services
        })
    },
    fetchCamps ({ commit, state }) {
      commit('setIsFetching', true)

      return ServiceService.getAllCamps()
        .then(({ camps }) => {
          commit('setCamps', camps)
          commit('setIsFetching', false)
          return camps
        })
    },
    fetchPds ({ commit, state }) {
      commit('setIsFetching', true)

      return ServiceService.getAllPds()
        .then(({ pds }) => {
          console.log(pds)
          commit('setPds', pds)
          commit('setIsFetching', false)
          return pds
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/services.js